import { render } from "./UserImage.vue?vue&type=template&id=029cdcd9&scoped=true"
import script from "./UserImage.vue?vue&type=script&lang=ts"
export * from "./UserImage.vue?vue&type=script&lang=ts"

import "./UserImage.vue?vue&type=style&index=0&id=029cdcd9&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-029cdcd9"

export default script